import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './shadow.inline.styl';
import './index.styl';

type Attrs = {
  'show-footer-links'?: boolean;
  'hide-header'?: boolean;
};

type JsxProps = {
  attrs?: Attrs;
};

export class AuthContainer extends Component<EmptyObj, Attrs> {
  static get attrsSchema(): AttrsSchema<Attrs> {
    return {
      'show-footer-links': `boolean`,
      'hide-header': `boolean`,
    };
  }
  get config() {
    return {
      css,
      useShadowDom: true,
      template,
    };
  }
}

export const AuthContainerEl = defineAndMakeJsxFactory<JsxProps>(`auth-container`, AuthContainer);
export const AuthContainerReact = panel2react<JsxProps>(`auth-container`, AuthContainer);
